import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddToCartModal from './AddToCartModal';
import { toast } from 'react-toastify';
import SecureShieldImg from '../Components/img/Secure Payment Shield.png'
import PhonePayLogoImg from '../Components/img/PhonePe-Logo.png'
import GPayLogoImg from '../Components/img/Google_Pay-Logo.png'
import VisaLogoImg from '../Components/img/Visa_Inc.-Logo.png'
import MasterLogoImg from '../Components/img/Mastercard-Logo.png'
import RupayLogoImg from '../Components/img/Rupay-Logo.png'
import PaytmLogoImg from '../Components/img/Paytm-Logo.png'
import img1 from "./img/100BILLION_ICON.png"

const products = [
    {
        id: 1,
        name: 'Product Name 1',
        deliveryStart: '27 March 2025',
        deliveryEnd: '30 March 2025',
        discountPrice: 100.00,
        originalPrice: 200.00
    },
    {
        id: 2,
        name: 'Product Name 2',
        deliveryStart: '28 March 2025',
        deliveryEnd: '31 March 2025',
        discountPrice: 120.00,
        originalPrice: 220.00
    },
    {
        id: 3,
        name: 'Product Name 3',
        deliveryStart: '29 March 2025',
        deliveryEnd: '1 April 2025',
        discountPrice: 150.00,
        originalPrice: 250.00
    }
];

const Cart = ({ fetchCartDataMainPage }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [cart, setCart] = useState([])
    const [duration, setDuration] = useState(() => {
        return sessionStorage.getItem("cart_duration") || "3y";
    });


    const login = JSON.parse(localStorage.getItem("login")) || false;
    const openModal = (product) => {
        setIsOpen(true);
        // fetchCartDataMain();
        fetchBenefitsData();
        console.log("hiiii")
    };
    const [benefitsData, setBenefitsData] = useState([]);
    const [showSplashImage, setShowSplashImage] = useState(false);



    const fetchBenefitsData = async () => {
        try {
            const response = await fetch('https://100billionrealestate.com/benefit/getall/details');
            const data = await response.json();
            const activeItems = data.filter(item => item.status === "Active");

            // Don't set benefitsData directly here
            const response2 = await fetch(`https://100billionrealestate.com/cart/getcartadded/${login.emplyee_ID}`);
            const cartData = await response2.json();
            const cartItemIds = cartData.map(item => String(item.item_id));

            const filtered = activeItems.filter(benefit => !cartItemIds.includes(String(benefit.id)));

            setBenefitsData(filtered); // Now set filtered data only once
        } catch (error) {
            console.error("Error fetching benefits or cart data:", error);
        }
    };


    const handleDelete = async (id) => {
        try {
            const response = await fetch(`https://100billionrealestate.com/cart/delete/${login.emplyee_ID}/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            const result = await response.json();
            if (response.ok) {
                console.log(result || "Deleted successfully");
                toast.success("Item removed", {
                    position: "top-center",
                    autoClose: 900,
                });
                fetchCartData();
                fetchBenefitsData();
                fetchCartDataMain();
                fetchCartDataMainPage();
            } else {
                toast.error(result.message, {
                    position: "top-center",
                    autoClose: 900, // Close toast after 3 seconds
                });
                console.error(result.message || "Failed to delete item");
            }
        } catch (error) {
            toast.error("Error while deleting", {
                position: "top-center",
                autoClose: 900, // Close toast after 3 seconds
            });

        }
    };

    const fetchCartDataMain = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/cart/getcartadded/${login.emplyee_ID}`);
            const data = await response.json();
            setCart(data);

            const cartItemIds = data.map(item => item.item_id);
            const filteredBenefits = benefitsData.filter(benefit => !cartItemIds.includes(String(benefit.id)));
            setBenefitsData(filteredBenefits);

        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
    };

    const fetchCartData = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/cart/getcartadded/${login.emplyee_ID}`)
            const data = await response.json();
            // const activeItems = data.filter(item => item.status === "Active");
            const total = data.reduce((acc, item) => acc + Number(item.product_price), 0);
            console.log(total);
            setCart(data)
        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
    };

    const getMultiplier = () => {
        switch (duration) {
            case "1y": return (12);
            case "3y": return (36 * 70 / 100);
            default: return 1;
        }
    };


    useEffect(() => {
        fetchCartData(); // for updating the cart panel
    }, []);



    return (
        <>
            <div className="cart-perfume">
                <div className="cart-perfume-header">Your cart</div>
                <div className="cart-columns-perfume">
                    <div className="cart-column1-perfume">
                        <div
                            className="cart-column1-coupon-perfume"
                            onClick={() => openModal(null)}
                        >
                            <i class="fa-solid fa-cart-plus"></i> Add more products
                        </div>
                        {cart.map((product) => (
                            <div key={product.id} className="cart-column1-product-perfume">
                                <div className="cart-product-card-perfume cart-product-details">
                                    <div className="cart-product-details-column1">
                                        <h3>{product.product_title}</h3>
                                        <p className="cart-description">{product.product_description}</p>
                                    </div>
                                    <div className="cart-product-details-column2">
                                        <button className="cart-remove-product" onClick={() => { handleDelete(product.id) }}>
                                            <i className="fa-solid fa-trash"></i>
                                        </button>
                                        <h3 className="cart-discount-price"><strong>₹{product.product_price}<span className='per-month-text-cart-checkout-hbt'>/Mo</span></strong></h3>
                                        <p className="cart-original-price">₹{product.product_ogprice}<span className='per-month-text-cart-checkout-hbt'>/Mo</span></p>
                                        <p className="cart-discount-percentage">
                                            {Math.floor(
                                                ((Number(product.product_ogprice) - Number(product.product_price)) / Number(product.product_ogprice)) * 100
                                            )}%
                                        </p>


                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="cart-column2-perfume">
                        <div className="cart-column2-header-perfume">
                            <h3>Order summary ({cart.length} items)</h3>
                            <div class="modern-select-v9">
                                <select
                                    value={duration}
                                    onChange={(e) => {
                                        setDuration(e.target.value);
                                        sessionStorage.setItem("cart_duration", e.target.value); // ✅ Save to localStorage
                                    }}
                                >

                                    <option value="1m">1 Month</option>
                                    <option value="1y">1 Year</option>
                                    <option value="3y">3 Years</option>
                                </select>
                                <i class="fas fa-chevron-down chevron-icon-v9"></i>
                            </div>

                        </div>
                        <div className="cart-column2-total-perfume">
                            <div className="cart-total-labels">
                                <p><strong>Price</strong></p>
                                <p>Discount</p>
                                <h3>Sub total</h3>
                            </div>
                            <div className="cart-total-value">
                                <div>
                                    <p>
                                        <span className='price-card-strike'>
                                            ₹{Math.round(cart.reduce((acc, p) => acc + Number(p.product_ogprice) * getMultiplier(), 0)).toLocaleString("en-IN")}
                                        </span>
                                        <strong>
                                            ₹{Math.round(cart.reduce((acc, p) => acc + Number(p.product_price) * getMultiplier(), 0)).toLocaleString("en-IN")}
                                        </strong>
                                    </p>
                                    <p>
                                        -₹{Math.round(
                                            cart.reduce((acc, p) => acc + Number(p.product_ogprice) * getMultiplier(), 0) -
                                            cart.reduce((acc, p) => acc + Number(p.product_price) * getMultiplier(), 0)
                                        ).toLocaleString("en-IN")}
                                    </p>
                                    <h3>
                                        ₹{Math.round(cart.reduce((acc, p) => acc + Number(p.product_price) * getMultiplier(), 0)).toLocaleString("en-IN")}
                                    </h3>
                                </div>


                            </div>
                        </div>
                        <div className="card-saved-value">
                            <img src={img1} alt="" className='card-saved-logo' />
                            <p>Nice! you saved ₹{Math.round(cart.reduce((acc, p) => acc + Number(p.product_ogprice) * getMultiplier(), 0) - cart.reduce((acc, p) => acc + Number(p.product_price) * getMultiplier(), 0)).toLocaleString("en-IN")}. On your order</p>
                        </div>
                        <div className="cart-checkout-btn">
                            {/* <button className="cart-checkout-btn" onClick={() => navigate("/checkout")}>Checkout</button> */}
                            <button
                                className={`cart-checkout-btn ${(!login || cart.length === 0) ? "disabled" : ""}`}
                                onClick={() => {
                                    if (!login) {
                                        toast.error("Please login first to proceed.");
                                    } else if (cart.length === 0) {
                                        toast.error("Your cart is empty.");
                                    } else {
                                        setShowSplashImage(true);
                                        setTimeout(() => {
                                            navigate("/checkout");
                                        }, 1500);
                                    }
                                }}
                            >
                                Checkout
                            </button>

                        </div>
                        <div className="checkout-secure-conatiner">
                            <div className="checkout-secure-text">
                                <p>Secure checkout with</p>
                            </div>
                            <div className="checkout-secure-img">
                                <img src={PhonePayLogoImg} alt="" />
                                <img src={GPayLogoImg} alt="" />
                                <img src={VisaLogoImg} alt="" />
                                <img src={MasterLogoImg} alt="" />
                                <img src={RupayLogoImg} alt="" />
                                <img src={PaytmLogoImg} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AddToCartModal
                fetchCartDataMainPage={fetchCartDataMainPage}
                fetchBenefitsData={fetchBenefitsData}
                benefitsData={benefitsData}
                setBenefitsData={setBenefitsData}
                fetchCartDataMain={fetchCartDataMain}
                fetchCartData={fetchCartData}
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            />

            {showSplashImage && (
                <div className="checkout-splash-overlay">
                    <h2 className="checkout-splash-head animate__animated animate__bounceInLeft">Secure payment</h2>
                    <p className='checkout-splash-para animate__animated animate__bounceInRight'><i class="fa-solid fa-lock"></i> End to end encrypted</p>
                    <img
                        src={SecureShieldImg}
                        alt="Checkout Splash"
                        className="checkout-splash-image animate__animated animate__zoomInUp"
                    />
                </div>
            )}
        </>
    );
};

export default Cart;